import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { useQuery } from '@tanstack/react-query'
import { logError } from '@node-space/utils'
import { BaseErrorResponse } from 'types/beneficiaries'
import { getDocument } from 'services/DocumentService'

export const usePopDownloadQuery = (url: string, enabled = false) => {
  return useQuery(reactQueryKeys.documentDownload(url), () => getDocument(url), {
    enabled: enabled,
    cacheTime: 1800000,
    onError: (error: BaseErrorResponse) => {
      logError('Error: usePopDownloadQuery', error, { url })
    },
  })
}
